"use strict";

function sortBlogList() {
    // sorts articles by date
    var articles = window.theme.articles;
    var sortedArticles = false;
    if (articles.length > 0) {
        sortedArticles = articles.sort(function (a, b) {
            return new Date(b.published_at) - new Date(a.published_at);
        });
    }

    return sortedArticles;
}

function readMore(string, maxWords) {
    var strippedString = $("<p>" + string + "</p>").text().trim();
    var array = strippedString.split(" ");
    var wordCount = array.length;
    var string = array.splice(0, maxWords).join(" ");

    if (wordCount > maxWords) {
        string += "...";
    }

    return string;
}

function buildBlogList() {
    var articles = sortBlogList();
    var html = '';

    if (articles) {
        articles.forEach(function (article) {
            var title = article.title;
            var desc = article.summary_html != '' ? article.summary_html : readMore(article.body_html.replace(/<[^>]*>?/gm, ''), 20);
            var flower = "\n                <div class=\"article--no-img d-flex justify-content-center align-items-center\">\n                    <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"52.125\" height=\"77.784\" viewBox=\"0 0 52.125 77.784\"><path id=\"Path_745\" data-name=\"Path 745\" d=\"M49.425,34.043S41.4,39.835,38.8,44.213C36.986,47.266,30.658,61.9,26.991,70.484L23.808,38.718l-.528-5.631c4.836-1.278,10.876-5.624,12.644-8,2.133-2.868-.7-17.077-3.522-20.2S18.148,0,18.148,0C14.086,1.776,8.54,5.644,7.4,8.563s-2.108,11.4-1.839,14.36C5.8,25.55,12.5,30.88,17.6,32.77l.544,16.766L19.312,64.4c-2.464-5.922-6.5-15.391-8.268-18.313C8.4,41.729,0,38.271,0,38.271S1.859,55.362,4.219,61.854C5.765,66.108,13.992,72,20.344,76.909l2.247-.057,0-.021,5.032-.083c6.768-5.3,21.525-19.667,22.658-24.612C51.81,45.446,49.425,34.043,49.425,34.043Z\" transform=\"matrix(1, 0.017, -0.017, 1, 1.342, 0)\" fill=\"#2a2a2a\"/></svg>\n                </div>";
            var img = article.image != undefined ? "<div class=\"article--image\" style=\"background-image: url(" + article.image.src + ");\" ></div>" : flower;
            console.log(article);

            html += "\n            <div class=\"col article  " + article.blog_handle + " \">\n                <div class=\"d-md-flex flex-column justify-content-between\">\n                    <a href=\"/blogs/" + article.blog_handle + "/" + article.handle + "\">\n                        " + img + "\n                    </a>\n                    <h2 class=\"article--title\">\n                        " + title + "\n                    </h2>\n\n                    <div class=\"article--desc\">\n                        <p>" + desc + "</p>\n                    </div>\n\n                    <div class=\"article--link\">\n                        <a href=\"/blogs/" + article.blog_handle + "/" + article.handle + "\">READ MORE</a>\n                    </div>\n                </div>\n            </div>\n\n            ";
        });
    }

    $('#articles-list').html(html);
    // return html;
}

console.log(buildBlogList());

$(document).on('click', '.blog_filter--li', function (e) {
    e.preventDefault();
    var blog = $(this).attr('data-blog');
    if (blog == 'all') {
        $('.article').show();
    } else {
        $('.article').hide();
        $('.' + blog).show();
    }

    $('.blog_filter--li').removeClass('active');
    $(this).addClass('active');

    $('html,body').animate({ scrollTop: $('#article-container').offset().top }, 'fast');
});